<template>
  <div class="dasai-all">
      <!-- 顶部banner -->
      <div class="dasai-banner">

      </div>
      <div class="dasai-content">
          <!-- 活动简介 -->
          <div class="dasai-txt">
              <div class="dasai-title">
                  <img src="../assets/dasai-jianjie.png" alt="###">
              </div>
              <div class="dasaimiaoshu">
                  <p>本次大赛由全国铁道职业教育教学指导委员会主办，铁道供电专业教学指导委员会、郑州铁路职业技术学院、广州铁路职业技术学院、郑州简意科技有限公司具体承办。各职业院校、铁路企业承担报名、初选工作。郑州简意科技有限公司提供技术支持。   </p>
              <p>参赛对象主要为全国铁路高等职业院校与中等职业院校在职铁道供电技术专业的专任教师、轨道交通供电企业专兼职培训师。
              </p>
              <p>参赛内容限定于铁道概论、电工基础、电机与电气控制技术、接触网运行检修与施工、变配电所运行检修与施工（含综合自动化技术）、电力线路安装与检修、高电压设备测试、供电安全规程、铁路供电系统等主要专业课程中选取。
              </p>
                </div>
              <div class="dasai-img1">
                  <!-- <img src="../assets/dasai-right-logo.png" alt=""> -->
              </div>

          </div>
          <!-- 活动节点 -->
          <div class="dasai-jd">
              <!-- 活动节点标题 -->
              <div class="dasai-jd-title">
                  <img src="../assets/dasaijiedian.png" alt="">
              </div>
              <!-- 节点内容 -->
              <div  class="dasai-jd-cont">
                  <div  class="dasai-jd-cont-list">
                      <div  class="dasai-jd-cont-listimg">
                          <img src="../assets/dasai-list1.png" alt="">
                      </div>

                      <p>校内选拔</p>
                      <span>由参赛院校先自行组织选拔，经选拔后推荐参赛作品</span>
                  </div>

                  <div  class="dasai-jd-cont-list">
                      <div  class="dasai-jd-cont-listimg">
                          <img src="../assets/dasai-list2.png" alt="">
                      </div>

                      <p>注册参选</p>
                      <span>
                                注册后将作品提交等待审核，审核通过后在平台进行展示
                      </span>
                  </div>

                  <div  class="dasai-jd-cont-list">
                      <div  class="dasai-jd-cont-listimg">
                          <img src="../assets/dasai-list3.png" alt="">
                      </div>

                      <p>评委评审</p>
                      <span>
                                提交作品由专家组组织对作品打分评审
                      </span>
                  </div>

                  <div  class="dasai-jd-cont-list">
                      <div  class="dasai-jd-cont-listimg">
                          <img src="../assets/dasai-list4.png" alt="">
                      </div>

                      <p>大赛颁奖</p>
                      <span>
                               评审后依据最终排名对获奖者进行颁奖，同时获奖人分享心得
                            </span>
                  </div>
              </div>

          </div>
          <!-- 评审 -->
              <div class="dasai-ps">
                  <!-- 左边图 -->
                  <div class="dasai-ps-leftimg">
                      <img src="../assets/dasai-zhimg.png" alt="###">
                  </div>
                  <!-- 右边内容 -->
                  <div class="dasai-ps-righttxt">
                      <div class="dasai-pspinglogo">
                     <img src="../assets/dasaiping.png" alt="###">
                      </div>
                     <div class="dasai-pstxt1">
                         <span>本次竞赛依托“全国铁道供电技术专业教学微课大赛”网站开展微课展示和网络评审活动。</span>
                     </div>
                     <div class="dasai-pstxt2">
                         <p>1、鼓励广大教师挖掘专业及课程的思政元素，有机融入课程教学内容，深化对专业、课程自身所蕴含的思想政治教育元素和所承载的思想政治教育功能的认识，适应新时代要求，发挥专业课程的育人功能。</p>
                         <p>
2、比赛作品展示采取匿名方式进行，赛事作品提交的视频、演示文稿、教学设计(教案) 等参赛资料的任何地方不得出现院校和教师的信息。
                         </p>
                         <p>
3、评委进入评审后台对每个微课进行浏览和评审，可采用“全国铁道供电技术专业微课大赛”网站评价功能对微课进行点评和交流。
                         </p>
                         <p>
4、评审采用网络打分形式，对所有参赛作品进行一等奖、二等奖和三等奖评选。
                         </p>
                         <p>
5、颁奖及优秀作品分享，大赛颁奖典礼将在2021年6月举行，获奖的教师代表将分享参赛作品及心得。
                         </p>
                     </div>

                  </div>
              </div>

      </div>
<botTom></botTom>


  </div>
</template>

<script>
import DaSaiall from "../css/DaSaiall.css"
import botTom from './BotTom'
export default {
data(){
    return{
        dslist:[1,2,3,4],
        dalistimg:['../assets/dasai-list1.png','../assets/dasai-list2.png','../assets/dasai-list3.png','../assets/dasai-list4.png']
    }
},
components:{
   botTom,
//    headtop
}
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/DaSaiall.vue